module.exports = __webpack_public_path__ + "img/logo-web-nv.4838df4e.svg";